module.exports = __webpack_public_path__ + "shipment_icon.png";